import { cn } from '@/lib/utils'

/** Unread/severity marker. Colour is backed by a screen-reader label. */
export function SeverityDot({ severity, unread }: { severity: 'info' | 'warning' | 'critical'; unread: boolean }) {
  const tone = severity === 'critical' ? 'bg-red' : severity === 'warning' ? 'bg-amber' : 'bg-accent'
  return (
    <span className="mt-1.5 grid size-2 shrink-0 place-items-center" aria-label={`${unread ? 'Unread' : 'Read'}${severity !== 'info' ? `, ${severity}` : ''}`} role="img">
      <span className={cn('size-2 rounded-full', unread ? tone : 'bg-line')} />
    </span>
  )
}

export const CATEGORY_LABEL: Record<string, string> = {
  security: 'Security',
  review: 'Reviews',
  memory: 'Memory',
  workspace: 'Workspaces',
  org: 'Organisation',
  billing: 'Billing',
  privacy: 'Privacy',
  data: 'Your data',
  developer: 'Developer',
  system: 'Product',
}
